export const NAMESPACE = 'prm';
